<template>

    <div class="row">

        <div class="col pt-2">

            <!--  Page  -->
            <div v-if="user_permissions.includes('read-macros') && user_permissions.includes('read-macro-categories')" class="bg-white rounded py-2 shadow-widget border">

                <!-- Page header -->
                <div class="px-3">

                    <div class="d-flex">

                        <h4>{{ $t('page.macros') }}</h4>

                        <div class="ml-auto align-self-center">
                          <div v-b-tooltip.hover.right="{
                               title:!user_permissions.includes('create-macros')? $t('permission.permission_denied', { permission: 'create-macros' }) : '',customClass: 'tooltip-dark' }"
                               style="display: inline-block">
                            <b-button  :variant="'primary'" :to="{
                                      name: 'macro_setup'}" :class="['ml-auto',{ 'cursor-not-allowed': !user_permissions.includes('create-macros') }]"
                                       :disabled="!user_permissions.includes('create-macros')">
                              <font-awesome-icon :icon="'plus'" />
                              {{ $t('default.add')}}
                            </b-button>
                          </div>
                        </div>

                    </div>

                    <span class="text-muted font-weight-light">{{ $t('page.macros_desc') }}</span>

                </div>

                <hr>

                <!-- Page content -->
                <div class="px-2">

                    <b-row>
                        <b-col>
                            <b-pagination hide-goto-end-buttons size="sm"
                                          @input="refreshMacros" :total-rows="macros_pagination.total" :value="macros_pagination.current_page" :per-page="macros_pagination.per_page">
                            </b-pagination>
                        </b-col>
                        <b-col md="4" class="my-2 ml-auto">
                            <b-input-group>
                              <b-form-input v-model="search" :placeholder="$t('simple.type_to_search')" type="search"></b-form-input>
                                <b-input-group-append>
                                  <b-btn :disabled="!search" @click="search = ''">{{ $t('simple.clear') }}</b-btn>
                                </b-input-group-append>
                            </b-input-group>
                        </b-col>
                    </b-row>

                    <v-wait for="macros">

                        <loading slot="waiting"/>

                        <template v-if="window_width >= 1200">
                            <b-table responsive bordered hover :items="macro_items" :fields="macro_fields">

                                <!-- Actions -->
                                <template slot="cell(actions)" slot-scope="cell">

                                  <b-dropdown right :text="$t('simple.actions')" size="sm">

                                    <b-dropdown-item :to="{
                                            name: 'macro_setup',
                                            params: { macro: cell.item }
                                        }" :class="!user_permissions.includes('update-macros') ? 'cursor-not-allowed' : ''"
                                                     v-b-tooltip.hover.right="{ title: !user_permissions.includes('update-macros') ? $t('permission.permission_denied', { permission: 'update-macros' }) : '', customClass: 'tooltip-dark' }"
                                                     :disabled="!user_permissions.includes('update-macros')">{{ $t('simple.edit') }}</b-dropdown-item>

                                    <b-dropdown-item @click="remove(cell.item.id)" :class="!user_permissions.includes('delete-macros') ? 'cursor-not-allowed' : ''"
                                                     v-b-tooltip.hover.right="{ title: !user_permissions.includes('delete-macros') ? $t('permission.permission_denied', { permission: 'delete-macros' }) : '', customClass: 'tooltip-dark' }"
                                                     :disabled="!user_permissions.includes('delete-macros')">{{ $t('simple.delete') }}</b-dropdown-item>

                                  </b-dropdown>

                                </template>

                                <!-- Created at -->
                                <template slot="cell(created_at)" slot-scope="cell">

                                     {{ $moment($moment.utc(cell.item.created_at)).local().format('YYYY-MM-DD HH:mm:ss') }}

                                </template>

                                <!-- Updated at -->
                                <template slot="cell(updated_at)" slot-scope="cell">

                                     {{ $moment($moment.utc(cell.item.updated_at)).local().format('YYYY-MM-DD HH:mm:ss') }}

                                </template>

                            </b-table>
                        </template>

                        <template v-else>
                            <b-table 
                                stacked="md"
                                small
                                responsive
                                bordered 
                                hover
                                :items="macro_items"
                                :fields="macro_fields_collapsed"
                            >

                            <!-- Actions -->
                            <template slot="cell(actions)" slot-scope="cell">

                                <b-button size="sm" @click="cell.toggleDetails()">
                                        {{ cell.detailsShowing ? 'Hide' : 'Show' }} Details
                                </b-button>

                                <b-dropdown right :text="$t('simple.actions')" size="sm" class="py-1">
                                
                                  <b-dropdown-item :to="{
                                          name: 'macro_setup',
                                          params: { macro: cell.item }
                                      }" :class="!user_permissions.includes('update-macros') ? 'cursor-not-allowed' : ''"
                                                   v-b-tooltip.hover.right="{ title: !user_permissions.includes('update-macros') ? $t('permission.permission_denied', { permission: 'update-macros' }) : '', customClass: 'tooltip-dark' }"
                                                   :disabled="!user_permissions.includes('update-macros')">{{ $t('simple.edit') }}</b-dropdown-item>

                                  <b-dropdown-item @click="remove(cell.item.id)" :class="!user_permissions.includes('delete-macros') ? 'cursor-not-allowed' : ''"
                                                   v-b-tooltip.hover.right="{ title: !user_permissions.includes('delete-macros') ? $t('permission.permission_denied', { permission: 'delete-macros' }) : '', customClass: 'tooltip-dark' }"
                                                   :disabled="!user_permissions.includes('delete-macros')">{{ $t('simple.delete') }}</b-dropdown-item>
                                  
                                </b-dropdown>

                            </template>

                            <template #row-details="row">
                                <b-table
                                    small
                                    stacked="md"
                                    class="d-xl-none"
                                    responsive
                                    bordered
                                    hover
                                    :items="[row.item]"
                                    :fields="macro_fields_not_collapsed"
                                >
                                <!-- Created at -->
                                <template slot="cell(created_at)" slot-scope="cell">

                                     {{ $moment($moment.utc(cell.item.created_at)).local().format('YYYY-MM-DD HH:mm:ss') }}

                                </template>

                                <!-- Updated at -->
                                <template slot="cell(updated_at)" slot-scope="cell">

                                     {{ $moment($moment.utc(cell.item.updated_at)).local().format('YYYY-MM-DD HH:mm:ss') }}

                                </template>
                                </b-table>
                            </template>

                            </b-table>
                        </template>

                    </v-wait>

                </div>
                    

            </div>
            <div class="alert alert-danger text-center mt-5" style="max-width: 50%; margin: 0 auto;" v-if="permissionsReady && (!user_permissions.includes('read-macros') || !user_permissions.includes('read-macro-categories'))">
              {{ $t('permission.permission_denied',{ permission: 'read-macros | read-macro-categories'}) }}
            </div>
        </div>

    </div>

</template>


<script>

    import MacrosDelete from './Modal/MacrosDelete.vue';

    import { create } from 'vue-modal-dialogs'
    import {mapActions, mapGetters} from "vuex";

    export default {

        mounted: async function () {
            // Component mounted
            console.log('Macro component mounted.');
            await this.fetchMacrosCategories();
            await this.refreshMacros(1);

            this.$nextTick(() => {
            window.addEventListener('resize', this.onResize);
        })

        },

        beforeDestroy() {
            window.removeEventListener('resize', this.onResize);
        },

        destroyed() {
            // Component destroyed
            console.log('Macro component destroyed.');
        },



        data: function() {
            return  {

                window_width: window.innerWidth,

                // Macro fields
                macro_fields: [
                    { key: 'name', label: this.$t('simple.name'), sortable: true  },
                    { key: 'description', label: this.$t('simple.desc'), sortable: true  },
                    { key: 'macros_category', label: this.$t('macros.category'), sortable: true  },
                    { key: 'created_at', label: this.$t('simple.created'), sortable: true  },
                    { key: 'updated_at', label: this.$t('simple.updated'), sortable: true },
                    { key: 'actions', label: this.$t('simple.actions') },
                ],

                macro_fields_collapsed: [
                    { key: 'name', label: this.$t('simple.name'), sortable: true  },
                    { key: 'description', label: this.$t('simple.desc'), sortable: true  },
                    { key: 'macros_category', label: this.$t('macros.category'), sortable: true  },
                    { key: 'actions', label: this.$t('simple.actions') },
                ],

                macro_fields_not_collapsed: [
                    { key: 'created_at', label: this.$t('simple.created') },
                    { key: 'updated_at', label: this.$t('simple.updated') },
                ],
            }
        },
        
        metaInfo: function() {

            return {
                title: this.$t('page.macros'),
            }
            
        },

        methods: {

            remove: async function(id) {

                // Show macros delete modal
                const macros_delete = create(MacrosDelete, 'id');

                if (await macros_delete(id) ){
                    // Refresh macros list
                    this.refreshMacros();
                }

            },

            refreshMacros: async function(page) {
                await this.fetchMacrosItems({ page: Number.isInteger(page) ? page : 1, search: this.search });
            },

            ...mapActions('Macro', [
                'fetchMacrosCategories',
                'fetchMacrosItems',
                'updateSearchMacros',
            ]),

            onResize() {
                this.window_width = window.innerWidth;
            },

        },

        computed: {

            // Map getters
            ...mapGetters({

                macro_items: 'Macro/getMacrosItems',
                macros_pagination: 'Macro/getMacrosPagination',
                getSearchMacros: 'Macro/getSearchMacros',
                user_permissions: 'User/getUserPermissions',
            }),
          permissionsReady() {
            return Array.isArray(this.user_permissions) && this.user_permissions.length > 0;
          },

          search: {
              get() {
                  return this.getSearchMacros;
              },
              set(newSearch) {
                  if (this.getSearchMacros !== newSearch) {
                      this.updateSearchMacros(newSearch);
                      this.refreshMacros(1);
                  }
              }
          },

        },

    }
</script>